// i18n area 'system' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.de-DE.meta.json.
import type { enUS } from './system'

export const deDE: typeof enUS = {
  diagnostics: {
    title: 'Diagnose',
    subtitle: 'Was nicht stimmt, das Schlimmste zuerst — dieselbe Linse wie tvirt diagnose',
    reload: 'Neu laden',
    loadError: 'Die Diagnose konnte nicht gelesen werden',
    exportBundle: 'Bundle exportieren',
    exportError: 'Das Bundle konnte nicht erstellt werden',
    noProblem: 'Kein Problem in den geprüften Bereichen',
    nothingInspected: 'NICHTS wurde geprüft — das ist kein Gesundheitszeugnis',
    inspected: 'Geprüft',
    notInspected: 'NICHT geprüft',
    localHint: 'Die knotenlokalen Bereiche (systemd-Units, Journal) gibt es nur in der CLI: tvirt diagnose --area local — der Weg, wenn die API nicht antwortet.',
    thresholds: 'fehlgeschlagene Tasks innerhalb {hours} h, Heartbeat älter als {seconds} s',
    severity: {
      critical: 'Kritisch',
      warning: 'Warnung',
      unknown: 'Unbekannt'
    }
  },
  explorer: {
    title: 'Ressourcen-Explorer',
    root: 'Wurzel',
    empty: 'Keine Ressource in diesem Scope',
    previewHint: 'Wählen Sie ein Objekt, um seine Vorschau zu sehen',
    open: 'Öffnen',
    openScoped: 'Die Liste in diesem Scope öffnen',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM-Template',
      ct: 'CT',
      ctTemplate: 'CT-Template',
      app: 'App',
      overlayNetwork: 'Overlay-Netzwerk',
      networkService: 'Netzwerkdienst',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Storage-Pool',
      disk: 'Festplatte',
      catalogFile: 'Katalogdatei',
      ociRegistry: 'OCI-Registry',
      ociImage: 'OCI-Image',
      cephCluster: 'Ceph-Cluster',
      backupDestination: 'Backup-Ziel',
      user: 'Benutzer',
      group: 'Gruppe',
      role: 'Rolle',
      credential: 'Zugangsdaten',
      tag: 'Tag',
      proximityRule: 'Proximitätsregel'
    }
  },
  tags: {
    title: 'Tags',
    empty: 'Keine Tags',
    add: 'Tag hinzufügen',
    remove: 'Entfernen',
    name: 'Tag',
    value: 'Wert',
    save: 'Speichern',
    saveError: 'Die Tags konnten nicht gespeichert werden',
    loadError: 'Das Tag-Vokabular konnte nicht geladen werden',
    noVocabulary: 'Kein Tag für diesen Ressourcentyp verfügbar',
    overwrite: 'Den aktuellen Wert ersetzen',
    createTitle: 'Tag erstellen',
    editTitle: 'Tag bearbeiten',
    nameHint: 'Buchstaben, Ziffern, Punkte, Bindestriche und Unterstriche — kein ":" und kein "/"; das Präfix tvirt- ist der Plattform vorbehalten',
    cardinality: 'Kardinalität',
    cardinalitySingle: 'Ein einziger Wert',
    cardinalityMultiple: 'Mehrere Werte',
    cardinalityHint: 'Bei einem einzigen Wert fragt das erneute Zuweisen des Tags, ob er ersetzt werden soll',
    autoCreate: 'Auto-Erstellung von Werten',
    autoCreateOn: 'Bei der Zuweisung',
    autoCreateOff: 'Nur deklarierte',
    autoCreateHint: 'An: das Zuweisen eines neuen Wertes erstellt ihn. Aus: nur die deklarierten Werte sind zuweisbar',
    values: 'Werte',
    noValues: 'Kein Wert deklariert',
    addValue: 'Wert hinzufügen',
    duplicateValue: 'Doppelter Wert',
    kinds: 'Ressourcentypen',
    kindsAll: 'Alle',
    kindsPlaceholder: 'Alle',
    kindsHint: 'Leer lassen, um jeden taggbaren Ressourcentyp zuzulassen',
    systemChip: 'System',
    deleteCascade: 'Auch die Zuweisungen entfernen',
    deleteCascadeHint: 'Ein Tag, der noch einer Ressource zugewiesen ist, wird abgelehnt: mit dieser Option verschwinden die Werte und alle Zuweisungen zusammen mit dem Tag.'
  },
  scopes: {
    title: 'Scopes',
    createTitle: 'Scope erstellen',
    editTitle: 'Scope umbenennen',
    path: 'Pfad',
    segment: 'Segment',
    segmentHint: 'Kleinbuchstaben, Ziffern und Bindestriche (DNS-1123)',
    parent: 'Übergeordnet',
    rootChip: 'Wurzel',
    preview: 'Neuer Scope',
    pickLabel: 'Scope',
    pickHint: 'Wo das Objekt im Clusterbaum lebt — die Wurzel oder ein vDC darunter.',
    ociCache: 'OCI-Cache (Override)',
    appEphemeral: 'Ephemerer App-Pool (Override)',
    inherit: 'Erben',
    inheritsFrom: 'Erbt von',
    inheritsCluster: 'Erbt den Cluster-Default',
    inheritsNone: 'Erbt — kein wirksamer Pool',
    failoverProtection: 'Schutz im degradierten Cluster',
    networkWeight: 'Netzwerkgewicht',
    networkCeil: 'Netzwerk-Obergrenze (Mbps)',
    protectionProtected: 'Geschützt',
    protectionExpendable: 'Im degradierten Zustand opferbar',
    protectionDefault: 'Cluster-Standard'
  },
  sysinfo: {
    summary: 'Plattformversionen im Cluster, Komponenten jedes Knotens, Administrationshandbuch und Lizenz.',
    platformTitle: 'TVirt-Plattform',
    platformSubtitle: 'Auf den Clusterknoten beobachtete Versionen',
    versionOnNodes: '{version} auf {n} Knoten',
    versionOnOneNode: '{version} auf 1 Knoten',
    mixedVersions: 'Mehr als eine Plattformversion im Cluster — nur während eines laufenden Upgrades erwartet (höchstens zwei).',
    tooManyVersions: 'Mehr als zwei Plattformversionen im Cluster — das ist nie erwartet, auch nicht während eines Upgrades: prüfen Sie die Knoten unten.',
    unreportedNodes: 'Noch kein Versionsreport von: {nodes}',
    noVersionsYet: 'Noch kein Knoten hat seine Versionen gemeldet.',
    nodesUnavailable: 'Die Knotenliste ist mit Ihren Berechtigungen nicht sichtbar — die Plattformversionen können nicht angezeigt werden.',
    colNode: 'Knoten',
    manualTitle: 'Administrationshandbuch',
    manualSubtitle: 'Lokale Kopie, von diesem Cluster ausgeliefert',
    manualBody: 'Das vollständige TVirt-Handbuch als PDF, direkt von der Plattform ausgeliefert — auch in air-gapped Umgebungen verfügbar.',
    manualLink: 'Administrationshandbuch (PDF)',
    apiExplorerTitle: 'API-Explorer',
    apiExplorerSubtitle: 'Der OpenAPI-Vertrag, navigierbar',
    apiExplorerBody: 'Der vollständige OpenAPI-Vertrag der Plattform — jede Route, jedes Schema und jeder Antwortcode — im Browser erkundbar, ausgeliefert über diesen Knoten.',
    apiExplorerLink: 'API erkunden',
    kubeTitle: 'Kubernetes-Kompatibilität',
    kubeSubtitle: 'kubectl und seine Werkzeuge, vor der nativen API',
    kubeBody: 'TVirt KubeCompat projiziert Pods, Deployments, Services, Namespaces, Knoten und Ereignisse im Kubernetes-Dialekt — nur lesend, plus das Löschen von Deployments. Jeder Aufruf läuft mit deinen Berechtigungen über die native API: verwende in der kubeconfig ein App-Token als Bearer.',
    kubeEndpoint: 'Endpoint für kubectl',
    kubeStatusActive: 'Aktiv — Kubernetes {version}',
    kubeStatusMissing: 'Auf diesem Knoten nicht installiert (Paket trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Installiert, antwortet aber nicht — prüfe die Unit trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Prüfung läuft…'
  },
  licensing: {
    title: 'Cluster-Lizenz',
    subtitle: 'Abonnement-Lizenz — höchstens eine pro Cluster',
    absentTitle: 'Keine Lizenz registriert',
    absentBody: 'Ohne gültige Lizenz weigert sich der Cluster, neue virtuelle Maschinen zu starten (eingeschaltete VMs bleiben eingeschaltet). Registrieren Sie den mit dem Abonnement erhaltenen Product Key.',
    registerButton: 'Lizenz registrieren',
    removeButton: 'Lizenz entfernen',
    state: {
      ok: 'Gültig',
      limitExceeded: 'Limit überschritten',
      expired: 'Abgelaufen'
    },
    productKeyLabel: 'Product Key',
    basisLabel: 'Basis des Limits',
    basis: {
      concurrentVms: 'Gleichzeitig eingeschaltete VMs',
      physicalCores: 'Physische Cores (Cluster gesamt)'
    },
    limitLabel: 'Limit',
    usageLabel: 'Aktuelle Nutzung',
    usageOf: '{used} von {limit}',
    usagePartial: 'Teilsumme — {n} Knoten ohne beobachtete CPU-Topologie',
    usageUnknown: 'derzeit nicht beobachtbar',
    expiresLabel: 'Ablauf',
    neverExpires: 'nie',
    registeredLabel: 'Registriert',
    gateNote: 'Bei fehlender, abgelaufener oder über dem Limit liegender Lizenz weigert sich der Cluster, NEUE virtuelle Maschinen zu starten. Eingeschaltete VMs bleiben eingeschaltet und HA-Neustarts sind nicht betroffen.',
    devStage: 'Entwicklungsphase: der Product Key wird unverändert zusammen mit den hier deklarierten Limits akzeptiert; die Validierung mit signiertem Schlüssel kommt in einer künftigen Release.',
    dialogTitle: 'Lizenz registrieren',
    dialogExpiresHelp: 'Leer = die Lizenz läuft nie ab',
    dialogSubmit: 'Registrieren',
    dialogError: 'Die Lizenz konnte nicht registriert werden.',
    removeTitle: 'Lizenz entfernen',
    removeBody: 'Der Cluster bleibt OHNE LIZENZ: neue virtuelle Maschinen werden sich weigern zu starten, bis Sie eine registrieren. Eingeschaltete VMs bleiben eingeschaltet.',
    removeConfirm: 'Entfernen',
    removeError: 'Die Lizenz konnte nicht entfernt werden.'
  },
  rbac: {
    tabRoles: 'Rollen',
    tabGrants: 'Delegationen',
    rolesTitle: 'Rollen',
    createRoleTitle: 'Rolle erstellen',
    editRoleTitle: 'Rolle bearbeiten',
    nameHint: 'Kleinbuchstaben, Ziffern und Bindestriche; das Präfix tvirt- ist reserviert',
    systemChip: 'System',
    permissions: 'Berechtigungen',
    permissionsPlaceholder: 'Berechtigung hinzufügen…',
    includedRoles: 'Enthaltene Rollen',
    includedRolesPlaceholder: 'Rolle hinzufügen…',
    grantsTitle: 'Delegationen',
    createGrantTitle: 'Delegation erstellen',
    principal: 'Principal',
    principalKind: 'Principal-Typ',
    principalUser: 'Benutzer',
    principalGroup: 'Gruppe',
    role: 'Rolle',
    grantRight: 'Delegation',
    grantRightChip: 'Darf delegieren',
    grantRightLabel: 'Mit Delegationsrecht (der Empfänger darf diese Rolle seinerseits weiterdelegieren)',
    effective: 'Wirksam',
    notEffective: 'Nicht wirksam',
    createdAt: 'Erstellt',
    scopeHint: '/path exakt, /path/* rekursiv — Delegationen verankern sich an einer gemounteten Wurzel (/* ist nicht delegierbar)'
  },
  groups: {
    title: 'Gruppen',
    createTitle: 'Gruppe erstellen',
    nameHint: 'Kleinbuchstaben, Ziffern und Bindestriche; eindeutig im Scope',
    members: 'Mitglieder',
    membersTitle: 'Mitglieder',
    membersPlaceholder: 'Benutzer hinzufügen…',
    noMembers: 'Keine Mitglieder',
    realmMappings: 'Realm-Zuordnungen',
    realmMappingsTitle: 'Realm-Zuordnungen',
    realmMappingsHint: 'Wem diese Gruppe in jedem externen Realm entspricht. Die Mitgliedschaft wird beim Anmelden aus der Directory gelesen: eine Directory-Gruppe, die hier niemand zuordnet, wird ignoriert, und Verschachtelung wird nicht aufgelöst — sie ist directory-seitig zu verflachen.',
    realm: 'Realm',
    externalGroup: 'Externe Gruppe',
    addRealmMapping: 'Zuordnung hinzufügen',
    removeRealmMapping: 'Zuordnung entfernen',
    noRealmMappings: 'Keine Realm-Zuordnungen',
    sectionGeneral: 'Allgemein',
    mappingsNoRealms: 'Kein externer Realm konfiguriert — die Zuordnungsoberfläche wird freigeschaltet, sobald ein Realm existiert.',
    mappingsNoRealmsLink: 'Den Tab Realms & SSO öffnen',

    // Die von der Gruppe auferlegte MFA-Pflicht (Round #178, Hälfte B): ein
    // reines OR — eine Gruppe kann die Pflicht nur HINZUFÜGEN, nie aufheben.
    mfaRequired: 'MFA-Pflicht',
    mfaRequiredChip: 'Erzwingt MFA',
    mfaNotRequiredChip: 'Keine Pflicht',
    mfaRequiredHint:
      'Ein reines OR: eine Gruppe kann die Pflicht zum zweiten Faktor für ihre Mitglieder HINZUFÜGEN — auch für externe Identitäten, über die Realm-Zuordnungen —, nie aufheben. Sie gilt ab der nächsten Anmeldung: offene Sitzungen werden nicht geschlossen.'
  },
  users: {
    title: 'Benutzer',
    createTitle: 'Benutzer erstellen',
    editTitle: 'Benutzer bearbeiten',
    username: 'Benutzername',
    usernameHint: 'Kleinbuchstaben, Ziffern, Punkte und Bindestriche',
    displayName: 'Anzeigename',
    enabled: 'Aktiviert',
    state: 'Status',
    enabledChip: 'Aktiviert',
    disabledChip: 'Deaktiviert',
    lockedChip: 'Gesperrt',
    password: 'Passwort',
    passwordSetChip: 'Gesetzt',
    mustChangeChip: 'Zu ändern',
    initialPassword: 'Initialpasswort',
    initialPasswordHint: 'Der Benutzer muss es bei der ersten Anmeldung ändern',
    lastLogin: 'Letzte Anmeldung',
    neverLoggedIn: 'Nie angemeldet',
    setPasswordTitle: 'Passwort setzen',
    setPasswordHint: 'Administratives Ersetzen — es erfordert Ihr Passwort (Sudo-Modus) und zwingt den Benutzer, es bei der nächsten Anmeldung zu ändern.',
    operatorPassword: 'Ihr Passwort',
    unlock: 'Den Account entsperren',
    revokeTitle: 'Sitzungen widerrufen',
    revokeBody: 'Alle aktiven Sitzungen dieses Benutzers werden sofort beendet.',
    revokeIncludeTokens: 'Auch die App-Tokens widerrufen',
    revokeConfirm: 'Widerrufen',
    tabAccount: 'Account',
    tabSecurity: 'Sicherheit',
    usernameImmutableHint: 'Der Benutzername ist die Identität des Accounts — bei der Erstellung fixiert',
    groups: 'Gruppen',
    noGroups: 'Keine Gruppen',
    mustChangePassword: 'Passwortwechsel erforderlich',
    failedAttempts: 'Fehlgeschlagene Anmeldeversuche',
    lockedUntil: 'Gesperrt bis',
    tabUsers: 'Benutzer',
    tabGroups: 'Gruppen',
    tabRealms: 'Realms & SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Zweiter Faktor (MFA)',
      methodsTitle: 'Verfügbare Methoden',
      methodsSubtitle: 'Was diese Installation als zweiten Faktor prüfen kann',
      methodsError: 'Die Methodenliste konnte nicht geladen werden',
      builtinChip: 'Integriert',
      enrollableChip: 'Enrollment in TVirt',
      delegatedChip: 'Extern verwaltet',
      state: 'Status',
      stateActive: 'Aktiv',
      statePending: 'Wartet auf Enrollment',
      stateNone: 'Nicht eingerichtet',
      required: 'MFA-Pflicht',
      requiredChip: 'Verpflichtend',
      notRequiredChip: 'Nicht verpflichtend',
      enrolledAt: 'Enrollment vom',
      enrolledMethods: 'Eingerichtete Methoden',
      noMethods: 'Kein Enrollment',
      codesRemaining: 'Verbleibende Wiederherstellungscodes',
      resetTitle: 'Zweiten Faktor zurücksetzen',
      resetHint:
        'Das Enrollment und alle Wiederherstellungscodes werden gelöscht: bei der nächsten Anmeldung richtet der Benutzer den zweiten Faktor neu ein. Die MFA-Pflicht bleibt unverändert — ein Administrator setzt nie ein Geheimnis, er löscht es nur.',
      resetConfirm: 'Zurücksetzen',
      resetError: 'Der zweite Faktor konnte nicht zurückgesetzt werden',
      empty: 'Noch kein verwalteter Benutzer — Konten erscheinen hier, sobald sie existieren, jedes mit seinem Zweitfaktor-Status.',

      // Hälfte B (Round #178): Herkunft des wirksamen Verdikts, externe
      // Enrollments mit dem Verwaist-Status, Gruppen, die die Pflicht auferlegen.
      viaSelf: 'Persönlich',
      viaSelfHint: 'Der persönliche Beitrag des Kontos (sein Flag) — der einzige Teil, den der Stift bearbeitet.',
      viaGroupHint: 'Von dieser Gruppe geerbte Pflicht: das persönliche Flag zu entfernen befreit den Benutzer nicht — man setzt an der Gruppe an, im Tab Gruppen.',
      subject: 'Identität',
      lastSeenAt: 'Zuletzt bestätigt',
      enrollmentPending: 'Ausstehend',
      orphanChip: 'Verwaist',
      orphanDirectoryMiss: 'Die Identität ist nicht mehr in der Directory',
      orphanRealmRemoved: 'Der Realm wurde aus TVirt entfernt',
      orphanedAt: 'Verwaist seit',
      directoryUuid: 'UUID in der Directory',
      externalTitle: 'Externe Enrollments',
      externalEmpty: 'Noch kein externes Enrollment — es entsteht bei der ersten Anmeldung einer Directory-Identität mit MFA-Pflicht.',
      orphanHelp:
        'Ein verwaistes Enrollment löscht sich nie von selbst: es ist Sicherheitsmaterial — es bleibt für das Audit, und taucht die Identität in der Directory wieder auf, findet sie ihren Faktor wieder. Der einzige Ausweg ist das administrative Zurücksetzen.',
      visibilityHint: 'Externe Enrollments residieren an der Wurzel des Clusters: nur wer user.read über den ganzen Baum hält, sieht sie.',
      orphanResetHint:
        'Die verwaiste Zeile wird endgültig entfernt: niemand beansprucht sie mehr. Taucht die Identität in der Directory wieder auf, richtet sie das Enrollment von Grund auf neu ein.',
      enforcingTitle: 'Gruppen, die MFA erzwingen',
      enforcingSubtitle:
        'Der Anker der Pflicht für externe Identitäten ist die Gruppe: ihre Realm-Zuordnungen sagen, welche Directory-Population sie erreicht. Das externe Enrollment entsteht bei der ersten Anmeldung des verpflichteten Benutzers.',
      enforcingEmpty: 'Keine Gruppe erzwingt MFA — die Pflicht wird an der Gruppe eingeschaltet, im Tab Gruppen.',
      enforcingError: 'Die Gruppen, die MFA erzwingen, konnten nicht geladen werden'
    }
  },
  realms: {
    title: 'Authentifizierungs-Realms',
    createTitle: 'Realm erstellen',
    editTitle: 'Realm bearbeiten',
    name: 'Realm',
    nameHint: 'Die Domain, die die Benutzer nach dem @ eingeben (example.com) — nach der Erstellung unveränderlich',
    nameImmutableHint: 'Der Realm-Name ist in jeder Sitzung und jeder Audit-Zeile gestempelt, die ihn je genannt hat — ihn umzubenennen würde die Geschichte umschreiben',
    kind: 'Typ',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC und SAML kommen mit den nächsten Rounds — heute ist ein Realm eine LDAPv3-Directory',
    kindCategory: 'Realm-Typ',
    kindSelectHint: 'Wählen Sie den Typ der Directory, gegen die dieser Realm authentifizieren wird.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Username und Passwort verifiziert mit einem Bind auf einer LDAPv3-Directory — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single Sign-on aus dem Browser, delegiert an einen OpenID-Connect-Identity-Provider — kommt mit den nächsten Rounds.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Unternehmens-Single-Sign-on mit SAML-2.0-Assertions — kommt mit den nächsten Rounds.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Aktiviert',
    urls: 'Directory-Server',
    urlsHint: 'Eine ldap://- oder ldaps://-URL pro Zeile (1–8), in Reihenfolge probiert — Failover, nie Balancing',
    startTls: 'StartTLS',
    verifyCertificate: 'Das Zertifikat verifizieren',
    cleartextWarning: 'Ohne ldaps:// oder StartTLS überquert das Bind-Passwort das Netz im Klartext — im Labor akzeptabel, in Produktion nie.',
    noVerifyWarning: 'Eine unverifizierte TLS-Sitzung authentifiziert niemanden: deaktivieren Sie die Verifikation nur gegenüber einer Directory, die Sie nicht reparieren können.',
    caCertificate: 'CA-Zertifikat (PEM)',
    caCertificateHint: 'Optionales CA-Bundle, gepinnt für den TLS/StartTLS-Handshake dieses Realms; leer entfernt es',
    caCertificatePinned: 'Gepinnt',
    connectTimeout: 'Timeout (Sekunden)',
    connectTimeoutHint: 'Frist pro URL für Verbindung und Anfrage (1–60); bei Ablauf wird die nächste URL probiert',
    bindDn: 'Bind DN',
    bindDnHint: 'Der Service-Account, der die Benutzersuche ausführt; leer = anonymer Search Bind (von AD abgelehnt)',
    anonymousBind: 'Anonymer Search Bind',
    bindCredential: 'Bind-Passwort (Keystore)',
    bindCredentialHint: 'Ein usernamePassword-Eintrag des Keystores mit dem Bind-Passwort — das Geheimnis lebt nie auf dem Realm',
    bindCredentialNone: 'Keines (anonymer Bind)',
    bindCredentialEmpty: 'Kein usernamePassword-Eintrag im Keystore — legen Sie unter System > Zugangsdaten einen für das Bind-Passwort an.',
    baseDn: 'Base DN',
    baseDnHint: 'Der Teilbaum, in dem die Benutzersuche startet (DC=example,DC=com)',
    userFilter: 'Benutzerfilter',
    userFilterHint: '%u wird durch den lokalen Teil des Logins ersetzt, mit RFC-4515-Escaping; Nicht-AD-Directories wollen typischerweise (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Attribut memberOf',
    memberOfAttributeHint: 'Ein einziges Mal gelesen, beim Login — nicht zugeordnete Gruppen werden ignoriert, Verschachtelung wird nicht aufgelöst',
    uuidAttribute: 'Attribut UUID',
    uuidAttributeHint: 'Die im Realm unveränderliche UUID (objectGUID auf AD, entryUUID auf OpenLDAP) — im Audit neben benutzer@realm gestempelt',
    displayNameAttribute: 'Attribut Anzeigename',
    displayNameAttributeHint: 'Wird verwendet, um den Benutzer zu begrüßen; andernfalls der Login-Name',
    sudoHint: 'Schreibzugriffe auf Realms sind sudo-geschützt: ein Realm ist eine Eingangstür in die Plattform',
    deleteBody: 'Die Gruppen-Zuordnungen des Realms gehen mit ihm; die von ihm authentifizierten Sitzungen bleiben bis zu ihrem Ablauf am Leben — ein gelöschter Realm lässt einfach niemanden Neues mehr herein.',
    tabConnection: 'Verbindung',
    tabDirectory: 'Directory',
    testTitle: 'Verbindung testen',
    testHint: 'Eine Konfigurationssonde, nie eine Authentifizierung: sie verbindet sich, macht den Bind mit dem Service-Account und führt — mit einem Benutzernamen — den Benutzerfilter aus.',
    testUsername: 'Benutzername (optional)',
    testUsernameHint: 'Ein lokaler Teil, auf dem der Benutzerfilter ausgeführt wird — 1 Treffer ist die gesunde Antwort',
    testRun: 'Test ausführen',
    testError: 'Die Sonde konnte nicht ausgeführt werden',
    testReachable: 'Directory erreichbar, Service-Bind akzeptiert',
    testUnreachable: 'Directory NICHT erreichbar',
    matchedOne: 'Der Benutzerfilter hat genau 1 Eintrag gefunden — die gesunde Antwort.',
    matchedNone: 'Der Benutzerfilter hat keinen Eintrag gefunden: der Filter oder der Base DN ist falsch.',
    matchedMany: 'Der Benutzerfilter hat {count} Einträge gefunden: er ist nicht selektiv, und die Logins wären mehrdeutig (abgelehnt).',
    mappingsPointer: 'Wem eine externe Gruppe entspricht, ist eine Eigenschaft der TVirt-Gruppe (ihre Realm-Zuordnungen): der Punkt der Wahrheit lebt im Tab Gruppen.',
    mappingsPointerLink: 'Den Tab Gruppen öffnen',
    rootHomeHint: 'Die Identitäten eines externen Realms leben in der Wurzel des Clusters, nie in einem vDC: Berechtigungen werden dort zugewiesen, wo sie gebraucht werden, per Delegationen — auf der Gruppe oder direkt auf dem Benutzer, genau wie bei nativen Benutzern.'
  },
  credentials: {
    title: 'Zugangsdaten',
    createTitle: 'Zugangsdaten erstellen',
    editTitle: 'Zugangsdaten bearbeiten',
    kind: 'Typ',
    kindUsernamePassword: 'Username und Passwort',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph-Identität)',
    kindHintUsernamePassword: 'Unveränderlich. Für CIFS/SMB-Storages — der Mount-Account, dessen Geheimnis der Worker beim Mounten verwendet.',
    kindHintIscsiChap: 'Unveränderlich. Für die iSCSI-CHAP-Authentifizierung — username = CHAP-Name, secret = CHAP-Geheimnis.',
    kindHintNvmeDhchap: 'Unveränderlich. Für das DH-HMAC-CHAP von NVMe over Fabrics — secret = der DHHC-1:xx:…-Blob; der Username ist nur eine Bezeichnung.',
    kindHintCephx: 'Unveränderlich. Für Ceph-Clients — username = Client-Name (client.…), secret = der Base64-Schlüssel.',
    kindImmutableHint: 'Der Typ ist nach der Erstellung unveränderlich — ihn zu ändern bedeutet neue Zugangsdaten.',
    username: 'Benutzername',
    usernameChap: 'CHAP-Name',
    usernameNvme: 'Bezeichnung',
    usernameCephx: 'Client-Name',
    usernameHint: 'Optionaler Account, zu dem das Geheimnis gehört',
    usernameHintChap: 'Der CHAP-Name, mit dem sich der Initiator authentifiziert',
    usernameHintNvme: 'Vom Transport nicht verwendet — eine freie Bezeichnung für Ihre Notizen',
    usernameHintCephx: 'Der Name des cephx-Clients — das Präfix client. wird toleriert',
    secret: 'Geheimnis',
    secretHint: 'Nur Schreiben: von den Konsumenten verwendet, nie wieder angezeigt.',
    secretHintNvmeDhchap: 'Nur Schreiben: das Host-DH-HMAC-CHAP-Geheimnis in der kanonischen Form DHHC-1:xx:… — von den Konsumenten verwendet, nie wieder angezeigt.',
    secretHintCephx: 'Nur Schreiben: der Base64-cephx-Schlüssel — von den Konsumenten verwendet, nie wieder angezeigt.',
    secretEditHint: 'Leer lassen, um das Geheimnis nicht zu ändern — es auszufüllen rotiert es.',
    createdAt: 'Erstellt',
    inUseError: "'{name}' wird von der Konfiguration eines Storage referenziert — lösen Sie sie zuerst dort.",
    nameHint: 'Kleinbuchstaben, Ziffern und Bindestriche (DNS-1123); eindeutig pro Scope',
    rotateTitle: 'Geheimnis rotieren',
    rotateHint: 'Nur Schreiben: das neue Geheimnis ersetzt das gespeicherte — die Konsumenten verwenden es beim nächsten Mount.',
    tabSecrets: 'Geheimnisse',
    tabCertificates: 'Zertifikate',
    tabAuthorities: 'Zertifizierungsstellen',
    certificatesTitle: 'Zertifikate',
    authoritiesTitle: 'Zertifizierungsstellen',
    caCreateTitle: 'Neue CA',
    certCreateTitle: 'Neues Zertifikat',
    caMode: 'Quelle',
    caModeGenerate: 'Mit TVirt generieren',
    caModeImport: 'Importieren (Schlüssel + Zertifikat)',
    certMode: 'Quelle',
    certModeIssue: 'Von einer Keystore-CA ausstellen',
    certModeImport: 'Importieren (Schlüssel + Zertifikat)',
    issuingCa: 'Ausstellende CA',
    issuingCaHint: 'Das Zertifikat entsteht im Scope der CA, mit registriertem Parent',
    noCasHint: 'Keine CA im Keystore — generieren oder importieren Sie zuerst eine im Tab CA',
    commonName: 'Common Name (CN)',
    commonNameCaHint: 'Der Subject der CA: Buchstaben, Ziffern, Leerzeichen, Punkt, Unterstrich, Bindestrich',
    commonNameCertHint: 'OpenVPN identifiziert die Clients am CN — halten Sie ihn pro CA eindeutig',
    days: 'Gültigkeit (Tage)',
    daysCaHint: '1–7300 Tage; 3650 (10 Jahre) ist der Default',
    daysCertHint: '1–3650 Tage; 365 ist der Default',
    keyType: 'Schlüsseltyp',
    keyTypeHint: 'EC P-256 ist der Default; RSA für Legacy-Konsumenten',
    usage: 'Verwendung',
    usageClient: 'Client (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Der Extended Key Usage, für den das Zertifikat ausgestellt wird',
    san: 'Alternative Namen (SAN)',
    sanHint: 'Kommagetrennt; IP-Literale werden IP:-Einträge, der Rest DNS:',
    keyPem: 'Privater Schlüssel (PEM)',
    keyPemHint: 'Nur Schreiben: im Keystore verwahrt, nie wieder angezeigt',
    certPem: 'Zertifikat (PEM)',
    certPemHint: 'Das öffentliche Zertifikat, das zum Schlüssel gehört',
    certPemCaHint: 'Das CA-Zertifikat, das zum Schlüssel gehört (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Aussteller',
    parentCa: 'Ausstellende CA',
    parentCaImported: 'Importiert — außerhalb von TVirt ausgestellt',
    serial: 'Seriennummer',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Gültig ab',
    validUntil: 'Gültig bis',
    expiry: 'Ablauf',
    expired: 'Abgelaufen',
    expiresInDays: 'Läuft in {days} T ab',
    revoked: 'Widerrufen',
    revokedAtLabel: 'Widerrufen am',
    revokeTitle: 'Zertifikat widerrufen',
    revokeAction: 'Widerrufen',
    revokeWarning: 'Der Widerruf ist endgültig: die Seriennummer wandert in die CRL der ausstellenden CA, und jeder Konsument, der widerrufene Zertifikate ablehnt (allen voran OpenVPN), wird dieses zurückweisen. Ein Un-Revoke existiert nicht.',
    exportPem: 'PEM exportieren',
    exportChain: 'Ketten-Bundle exportieren',
    exportCrl: 'CRL exportieren',
    materialImmutableHint: 'Das X.509-Material ist unveränderlich — stellen Sie neu aus oder importieren Sie neu',
    caInUseError: "'{name}' hat noch lebende ausgestellte Zertifikate (oder ein Storage referenziert sie) — widerrufen oder löschen Sie sie zuerst."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Platzierung, Verfügbarkeit und Affinität — wo die VMs des Clusters laufen und ob sie eingeschaltet sein sollen',
    loadError: 'Das Proximity-Panel benötigt den Cluster-Store — der Zustand der Flotte ist gerade nicht erreichbar',
    config: {
      title: 'Konfiguration',
      subtitle: 'Platzierungspolitik auf Cluster-Ebene',
      save: 'Speichern',
      saveError: 'Die Konfiguration wurde abgelehnt',
      strategy: 'Auswahlstrategie',
      strategy_leastUsedResources: 'Am wenigsten genutzte Ressourcen',
      strategy_leastVms: 'Wenigste VMs',
      strategy_random: 'Zufällig',
      strategyLeastUsedResourcesHint: 'Unter den gültigen Kandidaten der Knoten mit dem meisten verbleibenden nutzbaren RAM (beobachtetes Gesamt − Host-Reserve − eingeschaltete VMs), vCPU-Bindung als Stichentscheid. Deterministisch bei gleichen Daten.',
      strategyLeastVmsHint: 'Unter den gültigen Kandidaten der Knoten mit den wenigsten eingeschalteten VMs; Gleichstände lösen sich über den Namen. Deterministisch bei gleichen Daten.',
      strategyRandomHint: 'Gleichverteilt zufällig unter den gültigen Kandidaten.',
      liveness: 'Lebendigkeitsschwelle der Knoten (Sekunden)',
      livenessHint: 'Ein Mitglied, das länger als die Schwelle schweigt, ist unerreichbar: von der Platzierung ausgeschlossen und — wenn nicht in Wartung — vom HA-Decider als tot betrachtet, der es abriegelt und seine HA-VMs anderswo neu startet.',
      decider: 'HA-Decider',
      deciderNone: 'noch nicht gewählt'
    },
    nodesTitle: 'Knoten',
    nodesSubtitle: 'Lebendigkeit und empirische Kapazität — nutzbarer RAM = gesamt − Basis − gebunden',
    nodeCol: 'Knoten',
    stateCol: 'Status',
    ramCol: 'RAM (gesamt − Basis − gebunden)',
    usableCol: 'Nutzbar',
    vmsCol: 'Last',
    neverSeen: 'nie gesehen',
    freshChip: 'erreichbar',
    staleChip: 'unerreichbar',
    attestedChip: 'attestiert aus',
    ramFormula: 'gesamt − Basis − gebunden',
    haTitle: 'Hochverfügbarkeit',
    haSubtitle: 'VMs mit HA-Flag sind "immer eingeschaltet": TVirt startet sie nach jedem nicht angeforderten Stopp neu — gleicher Knoten mit Backoff, ein anderer Knoten, wenn ihrer stirbt (nur geteilter Storage).',
    haNone: 'Noch keine VM trägt das HA-Flag — aktivieren Sie es hier oder im VM-Detail.',
    haVmCol: 'Virtuelle Maschine',
    haStateCol: 'Status',
    haRestartsCol: 'HA-Neustarts',
    haLastEventCol: 'Letztes Ereignis',
    haToggleCol: 'HA',
    haCrashLoop: 'Crash-Loop',
    haToggleError: 'Die HA-Änderung wurde abgelehnt',
    rules: {
      title: 'Affinitätsregeln',
      createTitle: 'Neue Proximitätsregel',
      editTitle: 'Regel bearbeiten',
      nameHint: 'Kleinbuchstaben, Ziffern und Bindestriche (DNS-Label)',
      vms: 'Virtuelle Maschinen',
      vmsHint: 'Mindestens zwei VMs — die Regel bindet, wo sie relativ zueinander laufen',
      type: 'Typ',
      affinity: 'Affinität (zusammen)',
      antiAffinity: 'Anti-Affinität (getrennt)',
      typeAffinityHint: 'Die VMs sollen auf DEMSELBEN Knoten laufen.',
      typeAntiAffinityHint: 'Die VMs sollen auf VERSCHIEDENEN Knoten laufen — das klassische HA-Paar.',
      mode: 'Modus',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Verletzungen lehnen die Operation ab (Start, Migration, Failover) — mit einem sprechenden Fehler.',
      modeSoftHint: 'Präferenz, nie blockierend: eine verletzende Platzierung fährt mit sichtbarer Warnung fort.',
      satisfied: 'Platzierung',
      satisfiedYes: 'eingehalten',
      satisfiedNo: 'verletzt',
      violations: 'Verletzungen',
      noViolations: 'Keine'
    },
    events: {
      title: 'HA-Ereignisse',
      subtitle: 'Das Journal der Verfügbarkeit — Neustarts, Fencing, Failover und die ehrlichen Auslassungen',
      none: 'Noch nichts.',
      when: 'Wann',
      kind: 'Ereignis',
      target: 'Objekt',
      detail: 'Detail',
      kindRestarted: 'HA-Neustart',
      kindGaveUp: 'aufgegeben (Crash-Loop)',
      kindNodeAttested: 'Knoten abgeriegelt',
      kindFailedOver: 'Failover',
      kindNoCandidate: 'kein Kandidat',
      kindStorageLocalSkip: 'übersprungen (lokaler Storage)',
      kindZombieFenced: 'Zombie beendet'
    }
  }
}
